module.exports = __webpack_public_path__ + "img/icon-2.1e1309e.png";